import React from 'react';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import LogoGrid from '../components/common/LogoGrid';
import { partners } from '@/data/partners';
import { seo } from '@/data/seo';

const Partners = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.partners} />
      <PageHero
        eyebrow="Partners"
        title="Specialised manufacturers"
        highlight="and technology firms"
        description="MAYAN works with associated engineering, industrial, and technology partners to supply equipment, materials, and professional solutions."
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <LogoGrid items={partners} />
        </div>
      </section>
    </div>
  );
};

export default Partners;
